// extracted by mini-css-extract-plugin
export var cmtSDataItemContainer = "styles-module--cmt-s-data-item-container--4a58c";